import { IncorrectOptions } from '../types';

// This file contains incorrect conjugations for each verb/tense/pronoun
// Each verb has 3 plausible incorrect conjugations for each tense and pronoun
export const incorrectOptions: IncorrectOptions = {
  // Regular -er verbs (Group 1)
  'parler': {
    'present': {
      'je': ['parles', 'parle', 'parlons'],
      'tu': ['parle', 'parles', 'parlez'],
      'il': ['parles', 'parlons', 'parlent'],
      'nous': ['parlons', 'parlez', 'parlent'],
      'vous': ['parle', 'parlez', 'parlent'],
      'ils': ['parle', 'parlent', 'parlons']
    },
    'imparfait': {
      'je': ['parlais', 'parlait', 'parlaient'],
      'tu': ['parlais', 'parlait', 'parlaient'],
      'il': ['parlais', 'parlaient', 'parlions'],
      'nous': ['parlions', 'parliez', 'parlaient'],
      'vous': ['parliez', 'parlions', 'parlaient'],
      'ils': ['parlaient', 'parlais', 'parlait']
    },
    'futur_simple': {
      'je': ['parleras', 'parlera', 'parlerons'],
      'tu': ['parlerai', 'parlera', 'parlerez'],
      'il': ['parlerai', 'parleras', 'parleront'],
      'nous': ['parlerons', 'parlerez', 'parleront'],
      'vous': ['parlerez', 'parlerons', 'parleront'],
      'ils': ['parleront', 'parlerai', 'parleras']
    }
  },
  
  // Regular -ir verbs (Group 2)
  'finir': {
    'present': {
      'je': ['finis', 'finit', 'finissons'],
      'tu': ['finis', 'finit', 'finissez'],
      'il': ['finis', 'finissons', 'finissent'],
      'nous': ['finissons', 'finissez', 'finissent'],
      'vous': ['finissez', 'finissons', 'finissent'],
      'ils': ['finissent', 'finis', 'finit']
    },
    'imparfait': {
      'je': ['finissais', 'finissait', 'finissions'],
      'tu': ['finissais', 'finissait', 'finissiez'],
      'il': ['finissais', 'finissions', 'finissaient'],
      'nous': ['finissions', 'finissiez', 'finissaient'],
      'vous': ['finissiez', 'finissions', 'finissaient'],
      'ils': ['finissaient', 'finissais', 'finissait']
    },
    'futur_simple': {
      'je': ['finiras', 'finira', 'finirons'],
      'tu': ['finirai', 'finira', 'finirez'],
      'il': ['finirai', 'finiras', 'finiront'],
      'nous': ['finirons', 'finirez', 'finiront'],
      'vous': ['finirez', 'finirons', 'finiront'],
      'ils': ['finiront', 'finirai', 'finiras']
    }
  },
  
  // Irregular verbs (Group 3)
  'être': {
    'present': {
      'je': ['es', 'est', 'sommes'],
      'tu': ['suis', 'est', 'êtes'],
      'il': ['suis', 'es', 'sont'],
      'nous': ['sommes', 'êtes', 'sont'],
      'vous': ['êtes', 'sommes', 'sont'],
      'ils': ['sont', 'est', 'êtes']
    },
    'imparfait': {
      'je': ['étais', 'était', 'étions'],
      'tu': ['étais', 'était', 'étiez'],
      'il': ['étais', 'étions', 'étaient'],
      'nous': ['étions', 'étiez', 'étaient'],
      'vous': ['étiez', 'étions', 'étaient'],
      'ils': ['étaient', 'étais', 'était']
    },
    'futur_simple': {
      'je': ['seras', 'sera', 'serons'],
      'tu': ['serai', 'sera', 'serez'],
      'il': ['serai', 'seras', 'seront'],
      'nous': ['serons', 'serez', 'seront'],
      'vous': ['serez', 'serons', 'seront'],
      'ils': ['seront', 'serai', 'seras']
    }
  },
  
  'avoir': {
    'present': {
      'je': ['as', 'a', 'avons'],
      'tu': ['ai', 'a', 'avez'],
      'il': ['ai', 'as', 'ont'],
      'nous': ['avons', 'avez', 'ont'],
      'vous': ['avez', 'avons', 'ont'],
      'ils': ['ont', 'a', 'avez']
    },
    'imparfait': {
      'je': ['avais', 'avait', 'avions'],
      'tu': ['avais', 'avait', 'aviez'],
      'il': ['avais', 'avions', 'avaient'],
      'nous': ['avions', 'aviez', 'avaient'],
      'vous': ['aviez', 'avions', 'avaient'],
      'ils': ['avaient', 'avais', 'avait']
    },
    'futur_simple': {
      'je': ['auras', 'aura', 'aurons'],
      'tu': ['aurai', 'aura', 'aurez'],
      'il': ['aurai', 'auras', 'auront'],
      'nous': ['aurons', 'aurez', 'auront'],
      'vous': ['aurez', 'aurons', 'auront'],
      'ils': ['auront', 'aurai', 'auras']
    }
  },
  
  'aller': {
    'present': {
      'je': ['vas', 'va', 'allons'],
      'tu': ['vais', 'va', 'allez'],
      'il': ['vais', 'vas', 'vont'],
      'nous': ['allons', 'allez', 'vont'],
      'vous': ['allez', 'allons', 'vont'],
      'ils': ['vont', 'va', 'allez']
    },
    'imparfait': {
      'je': ['allais', 'allait', 'allions'],
      'tu': ['allais', 'allait', 'alliez'],
      'il': ['allais', 'allions', 'allaient'],
      'nous': ['allions', 'alliez', 'allaient'],
      'vous': ['alliez', 'allions', 'allaient'],
      'ils': ['allaient', 'allais', 'allait']
    },
    'futur_simple': {
      'je': ['iras', 'ira', 'irons'],
      'tu': ['irai', 'ira', 'irez'],
      'il': ['irai', 'iras', 'iront'],
      'nous': ['irons', 'irez', 'iront'],
      'vous': ['irez', 'irons', 'iront'],
      'ils': ['iront', 'irai', 'iras']
    }
  },
  
  // Reflexive verb example
  'se promener': {
    'present': {
      'je': ['te promène', 'se promène', 'promène'],
      'tu': ['me promènes', 'se promène', 'promènes'],
      'il': ['me promène', 'te promène', 'promène'],
      'nous': ['vous promenons', 'se promènent', 'promenons'],
      'vous': ['nous promenez', 'se promènent', 'promenez'],
      'ils': ['me promènent', 'te promènent', 'promènent']
    },
    'imparfait': {
      'je': ['te promenais', 'se promenait', 'promenais'],
      'tu': ['me promenais', 'se promenait', 'promenais'],
      'il': ['me promenait', 'te promenais', 'promenait'],
      'nous': ['vous promenions', 'se promenaient', 'promenions'],
      'vous': ['nous promeniez', 'se promenaient', 'promeniez'],
      'ils': ['me promenaient', 'te promenaient', 'promenaient']
    },
    'futur_simple': {
      'je': ['te promèneras', 'se promènera', 'promènerai'],
      'tu': ['me promènerai', 'se promènera', 'promèneras'],
      'il': ['me promènerai', 'te promèneras', 'promènera'],
      'nous': ['vous promènerez', 'se promèneront', 'promènerons'],
      'vous': ['nous promènerons', 'se promèneront', 'promènerez'],
      'ils': ['me promènerai', 'te promèneras', 'promèneront']
    }
  }
};

// This file will be expanded with a script to include all verbs
// For now, it contains examples for each verb type (regular -er, -ir, irregular, reflexive)
